export * from '@primeuix/themes/lara/chip';
export { default } from '@primeuix/themes/lara/chip';
